(() => {
  'use strict';
  if (window.MayLondonTyping) return;
  const config=document.getElementById('MayLondonTypingData');
  if (!config) return;
  const phrases=JSON.parse(config.textContent).filter(text=>typeof text==='string'&&text.trim());
  if (!phrases.length) return;
  const selector='.v19-home__search input[name="q"], [data-predictive-input], [data-studio-filters] input[name="query"], [data-v19-stylist] textarea[name="notes"], [data-v19-livechat] textarea[name="message"]';
  const states=new Map(), motion=matchMedia('(prefers-reduced-motion: reduce)');
  const stop=(state,restore=true)=>{clearTimeout(state.timer);state.timer=null;if(restore)state.input.placeholder=state.original;};
  function start(state) {
    stop(state);
    if(state.done||state.engaged||state.input.value||state.input.disabled||!state.visible||document.hidden||motion.matches)return;
    const tick=()=>{
      if(!state.input.isConnected||state.input.value||state.input.disabled||state.engaged||!state.visible||document.hidden||motion.matches){stop(state);return;}
      const phrase=phrases[state.index];
      // A short invitation, not an endlessly moving placeholder.
      if(performance.now()-state.started>=4600){state.input.placeholder=phrase;state.done=true;state.timer=null;return;}
      state.length+=state.deleting?-1:1;
      state.input.placeholder=phrase.slice(0,state.length);
      let delay=state.deleting?14:55;
      if(state.length===phrase.length){state.deleting=true;delay=450;}
      else if(state.length===0){state.index=(state.index+1)%phrases.length;state.deleting=false;delay=160;}
      state.timer=setTimeout(tick,delay);
    };
    state.started=performance.now();state.index=0;state.length=0;state.deleting=false;
    state.timer=setTimeout(tick,350);
  }
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const state=states.get(entry.target);if(!state)return;
    state.visible=entry.isIntersecting;if(state.visible)start(state);else stop(state);
  }));
  function init() {
    for(const [input,state] of states)if(!input.isConnected){stop(state);observer.unobserve(input);state.events.abort();states.delete(input);}
    document.querySelectorAll(selector).forEach(input=>{
      if(states.has(input))return;
      const state={input,original:input.placeholder,visible:false,done:false,engaged:false,events:new AbortController()};states.set(input,state);
      const engage=()=>{state.engaged=true;stop(state);},options={signal:state.events.signal};
      for(const event of ['pointerdown','keydown','input','compositionstart'])input.addEventListener(event,engage,options);
      input.addEventListener('blur',()=>{state.engaged=false;if(!input.value)start(state);},options);
      input.dataset.typingReady='true';observer.observe(input);
    });
  }
  document.addEventListener('visibilitychange',()=>states.forEach(state=>document.hidden?stop(state):start(state)));
  motion.addEventListener('change',()=>states.forEach(state=>motion.matches?stop(state):start(state)));
  new MutationObserver(init).observe(document.body,{childList:true,subtree:true});
  window.MayLondonTyping={init};init();
})();
